module.exports = __webpack_public_path__ + "static/media/03.f37e60a1.mp3";